import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Marker } from '../../../eacds/index/marker.class';
import { Device } from '../../models';
import { DeviceService, SyncService } from '../../services';
declare const google;

@Component({
  selector: 'device-details-card',
  templateUrl: './device-details-card.component.html',
})
export class DeviceDetailCardComponent implements OnInit {
  @Input() public device: Device;
  public scheduledTimeOutput: string[] = [];
  public settings;
  public map;
  public marker;
  public dragMarker;

  constructor(
    private deviceService: DeviceService,
    private toastr: ToastrService,
    private syncService: SyncService) {
  }

  public ngOnInit(): void {
    this.getSettings();
    this.marker = this.buildMarker(this.device);
  }

  public ngOnChanges(changes) {
    this.scheduledTime();
    this.marker = this.buildMarker(this.device);
  }

  public onMarkerDragStart() {
    const lng: number = this.marker.device.details.location[0];
    const lat: number = this.marker.device.details.location[1];
    const address: string = this.marker.device.details.address;
    this.dragMarker = {
      deviceId: this.marker.device._id,
      start: { lat, lng, address },
      end: { lat: 0, lng: 0, address: '' },
    };
    this.marker.draggable = true;
  }

  public async onMarkerDrop(event: any) {
    const address: string = await this.geocodePosition({ lat: event.coords.lat, lng: event.coords.lng });
    this.dragMarker.end = { lat: event.coords.lat, lng: event.coords.lng, address };
    this.marker.lat = this.dragMarker.end.lat;
    this.marker.lng = this.dragMarker.end.lng;
  }

  public onMarkerDragCancel() {
    this.marker.lat = 0;
    this.marker.lng = 0;
    this.marker.lat = this.dragMarker.start.lat;
    this.marker.lng = this.dragMarker.start.lng;
    this.marker.draggable = false;
    this.dragMarker = null;
  }

  public onMarkerDragSaveLocation() {
    // enabled drag'n drop
    this.marker.draggable = !this.marker.draggable;
    const location = [this.dragMarker.end.lng, this.dragMarker.end.lat] || [0, 0];
    const data: any = {
      details: {
        location,
        address: this.dragMarker.end.address,
      },
    };

    this.deviceService
      .update(this.marker.device._id, data)
      .subscribe((data) => {

      });
  }

  public mapReady(event: any) {
    // this.mapLoading = false;
    this.map = event;
    this.map.lat = this.marker.lat;
    this.map.lng = this.marker.lng;
    this.map.zoom = 14;
  }

  public scheduledTime() {
    if (this.device.config.scheduled) {
      let hoursMinutes;
      hoursMinutes = this.convertHoursMinutes(this.device.config.scheduled.start);
      this.scheduledTimeOutput[0] = hoursMinutes[0] + 'h' + hoursMinutes[1];

      // end
      hoursMinutes = this.convertHoursMinutes(this.device.config.scheduled.end);
      this.scheduledTimeOutput[1] = hoursMinutes[0] + 'h' + hoursMinutes[1];
    }
  }

  public getSettings() {
    this.syncService.getSettings().subscribe((settings) => {
      this.settings = settings;
    });
  }

  public convertHoursMinutes(hours) {
    return [Math.floor(hours / 60), hours % 60];
  }

  public deviceStatus(device: Device) {
    if (!device.connection || !('connected' in device.connection)) {
      return 'unknown';
    }
    if (device.connection.connected) {
      if (device.config.scheduled &&
        'scheduledPause' in device.details &&
        device.details.scheduledPause) {
        return 'scheduledPause';
      }
      return 'online';
    }
    return 'offline';
  }
  private buildMarker(device: Device): Marker {
    const online = (device.connection && device.connection.connected) ? true : false;
    let lat = 0;
    let lng = 0;
    if (device && device.details && device.details.location && device.details.location.length) {
      lng = device.details.location[0] || 0;
      lat = device.details.location[1] || 0;
    }
    const marker: Marker = new Marker(lat, lng, false, device);
    // marker color
    if (device.syncStatus == 'syncing') {
      marker.setIconUrl((online) ? 'blue' : 'yellow');
    } else {
      marker.setIconUrl((online) ? 'green' : 'red');
    }
    if (this.map) {
      this.map.lat = lat;
      this.map.lng = lng;
      this.map.zoom = 14;
    }
    return marker;
  }
  private geocodePosition(pos): Promise<string> {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ latLng: pos }, (results, status) => {
        if (status.toString() == google.maps.GeocoderStatus.OK) {
          // console.log('geocodePosition', results[0].formatted_address);
          resolve(results[0].formatted_address);
        } else {
          this.toastr.warning(status.toString(), 'Cannot determine address at this location');
          resolve(null);
        }
      });
    });
  }
}
